module.exports = __webpack_public_path__ + "img/vue-quiz.29410a07.png";